import React, { useRef, useState } from 'react';
import { Play, Pause, PlaySkipBack, PlaySkipForward } from 'react-ionicons';
import { Container, Circle } from './PlayButtonsComponents';
import { useSelector, useDispatch } from 'react-redux';
import ReactHowler from 'react-howler';
import * as localForage from 'localforage';
import {
  filterRecents,
  updateCurrentPlayingStation,
  updateTimeStampOnStationList,
} from '../../store/features/stationSlice';
import {
  setIsBuffering,
  setOldStationTo,
  togglePlayingState,
} from '../../store/features/playerSlice';
import BufferLoader from './BufferLoader';

const PlayButtons = () => {
  const recentStorage = localForage.createInstance({
    name: 'recent',
  });

  const playerRef = useRef(null);
  const currentVolume = useSelector((state) => state.player.playingVolume);
  const { currentStation, isBuffering, oldStation } = useSelector(
    (state) => state.player,
  );
  const dispatch = useDispatch();

  const showPlayingIcon = () => (
    <Play
      style={{ paddingLeft: '4px', paddingTop: '4px' }}
      color={'#0C5BA3'}
      width="30px"
      height="30px"
    />
  );

  const showPausedIcon = () => (
    <Pause
      style={{ paddingTop: '4px' }}
      color={'#0C5BA3'}
      width="30px"
      height="30px"
    />
  );

  const addToStorageRecents = async (stationToSave) => {
    let SavedStation = Object.assign({}, stationToSave);
    SavedStation.LastListened = Date.now();
    let data = (await recentStorage.getItem('recents')) ?? [];
    let breakFunction = false;
    if (data.length) {
      data.forEach((station) => {
        if (typeof station != 'undefined') {
          if (station.Id === SavedStation.Id) {
            breakFunction = true;
            return;
          }
        }
      });

      if (breakFunction) {
        return;
      }
    }
    await recentStorage.setItem('recents', [...data, SavedStation]);
  };

  const togglePlaying = async () => {
    if (oldStation.Id !== currentStation.Id) {
      dispatch(setOldStationTo(currentStation));
      dispatch(setIsBuffering(true));
    }
    dispatch(updateCurrentPlayingStation(currentStation));
    dispatch(togglePlayingState());
    dispatch(updateTimeStampOnStationList(currentStation));
    addToStorageRecents(currentStation);
    dispatch(filterRecents());
  };

  const previousArrow = () => (
    <div
      style={{
        marginLeft: 'auto',
        marginRight: '20px',
        cursor: 'pointer',
        zIndex: 3,
      }}>
      <PlaySkipBack color={'#fff'} width="30px" height="30px" />
    </div>
  );

  const nextArrow = () => (
    <div
      style={{
        marginLeft: '20px',
        marginRight: ' auto',
        cursor: 'pointer',
        zIndex: 3,
      }}>
      <PlaySkipForward color={'#fff'} width="30px" height="30px" />
    </div>
  );

  return (
    <Container style={{ width: '100%' }}>
      {previousArrow()}
      <Circle onClick={() => togglePlaying()}>
        <ReactHowler
          volume={currentVolume}
          playing={currentStation.IsPlaying}
          ref={playerRef}
          src={currentStation.Source}
          onPlay={() => dispatch(setIsBuffering(false))}
          html5={true}
        />
        {currentStation.IsPlaying && isBuffering ? (
          <BufferLoader />
        ) : currentStation.IsPlaying ? (
          showPausedIcon()
        ) : (
          showPlayingIcon()
        )}
      </Circle>
      {nextArrow()}
    </Container>
  );
};

export default PlayButtons;
